/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DIALOG_WIDTH_M } from '@app/common/constants/dialog-width';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { DialogPromptComponent, PromptData } from './dialog-prompt.component';

@Injectable({ providedIn: 'root' })
export class Prompt {
  constructor(private dialog: MatDialog) {}

  changeValue(params: PromptData): Observable<string> {
    return this.dialog
      .open<DialogPromptComponent, PromptData, string>(DialogPromptComponent, {
        width: DIALOG_WIDTH_M,
        data: params,
      })
      .afterClosed()
      .pipe(filter((v): v is string => !!v));
  }
}
